import { redirect, type RouteObject } from 'react-router'

/**
 * Creates routes for the account management feature.
 */
export function createRoutes(): RouteObject[] {
  return [
    {
      path: 'activity',
      lazy: {
        Component: () =>
          import('@/features/activity/ActivityView/ActivityViewContainer').then(
            (r) => r.default,
          ),
      },
      children: [
        {
          path: 'preferences',
          element: null,
        },
      ],
    },
    {
      path: 'notifications',
      loader: () => redirect('/activity'),
      children: [
        {
          path: 'preferences',
          loader: () => redirect('/activity/preferences'),
          element: null,
        },
      ],
    },
  ]
}
